import { modules } from '@veritone/glc-redux';
const {
  config: { getConfig },
} = modules;

const getApiRoot = (state: any) => {
  const config = getConfig<Window['config']>(state);
  return config.apiRoot;
};

export default getApiRoot;
